export default "__VITE_ASSET__9ABgzb2Z__"